export default __webpack_public_path__ + "static/media/security.f42ca8f0.svg";